import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { Consumer } from 'src/app/general/interfaces/functions';
import { DisputeDialogComponent, DisputeDialogData } from './dispute-dialog.component';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public getDisputeData(): void {
//   this.disputeDialogService.openDialog(
//     /* onUpdate */ outputDialogData => {
//       console.log(outputDialogData);
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class DisputeDialogService {

  constructor(private dialog: MatDialog) { }

  public openDialog(onUpdate: Consumer<DisputeDialogData>) : CloseDialog {
    const dialogRef = this.dialog.open(DisputeDialogComponent, {
      data: {},
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(outputDialogData => {
      if (outputDialogData) {
        onUpdate(outputDialogData);
      }
    });

    return () => dialogRef.close();
  }
}
